var _circle, _circle2, _line, _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 52,
    viewBox: "0 0 106 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 26,
    r: 3.5,
    fill: "#254E9C",
    stroke: "#254E9C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 26,
    r: 3.5,
    fill: "#254E9C",
    stroke: "#254E9C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 26,
    x2: 105,
    y2: 26,
    stroke: "#254E9C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#254E9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4217 28.2204C61.8272 28.2206 62.2171 28.3855 62.5106 28.6808C62.8041 28.9761 62.9787 29.3793 62.9982 29.8068C63.0177 30.2342 62.8806 30.6532 62.6153 30.9769C62.35 31.3006 61.9769 31.5042 61.5733 31.5455L61.4217 31.5533H48.3902L49.9061 33.1531C50.1932 33.455 50.3593 33.8619 50.37 34.2896C50.3807 34.7172 50.2352 35.1328 49.9636 35.4503C49.6919 35.7678 49.315 35.9629 48.9108 35.9952C48.5066 36.0275 48.1061 35.8946 47.7922 35.6239L47.6722 35.5094L43.6414 31.2544C42.616 30.1724 43.2835 28.347 44.6846 28.2271L44.832 28.2204H61.4217ZM56.095 16.4886C56.3712 16.1969 56.7401 16.0236 57.1303 16.0022C57.5206 15.9809 57.9045 16.113 58.2078 16.3731L58.3278 16.4875L62.3586 20.7425C63.384 21.8246 62.7165 23.6499 61.3154 23.7699L61.168 23.7765H44.5783C44.1728 23.7763 43.7829 23.6115 43.4894 23.3161C43.1959 23.0208 43.0213 22.6176 43.0018 22.1902C42.9823 21.7627 43.1194 21.3437 43.3847 21.02C43.65 20.6963 44.0231 20.4927 44.4267 20.4514L44.5783 20.4436H57.6098L56.0939 18.8439C55.7982 18.5314 55.6321 18.1078 55.6321 17.6662C55.6321 17.2246 55.7993 16.8011 56.095 16.4886Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#254E9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.9ec055fd3b0303c073017b22c4c016e2.svg";
export { ForwardRef as ReactComponent };